export default "/_next/static/images/img4-23310e1185a73e9a2fd34b7addef6744.png";